exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Source___J1262 {\n  padding: 0.25rem;\n  border-top: 1px solid var(--color-border);\n}\n\n.SourceHeaderRow___11O5s {\n  display: flex;\n  align-items: center;\n  min-height: 24px;\n}\n\n.SourceHeader___z9MSo {\n  flex: 1 1;\n  font-family: var(--font-family-sans);\n}\n\n.SourceOneLiner____wx6W {\n  font-family: var(--font-family-monospace);\n  font-size: var(--font-size-monospace-normal);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 100%;\n  margin-left: 1rem;\n}\n", ""]);

// exports
exports.locals = {
	"Source": "Source___J1262",
	"SourceHeaderRow": "SourceHeaderRow___11O5s",
	"SourceHeader": "SourceHeader___z9MSo",
	"SourceOneLiner": "SourceOneLiner____wx6W"
};